import AUTH_API from '@services/auth.service';
import {
  ICurrentLeaderboardResponse,
  ILastLeaderboardResponse,
} from '@models/interfaces/leaderboard.interface';
import convertToFormData from '@utils/helpers/convertToFormData';
import { IDefaultResponse } from '@models/interfaces/global.interface';

const LeaderboardService = {
  async getCurrentLeaderboard() {
    return await AUTH_API.post<ICurrentLeaderboardResponse>(
      `leaderboard/get_current_leaderboard`,
    );
  },

  async getLastLeaderboard() {
    return await AUTH_API.post<ILastLeaderboardResponse>(
      `leaderboard/get_last_month_leaderboard_grouping`,
    );
  },

  async dismissLeaderboardPopup(id: number) {
    return await AUTH_API.post<IDefaultResponse>(
      `leaderboard/dismiss_new_leaderboard_popup`,
      convertToFormData({ leaderboard_student_grouping_id: id }),
    );
  },
};

export default LeaderboardService;
